import React, { useRef } from "react"
import gsap from "gsap"
import { graphql, useStaticQuery } from "gatsby"
import { Video } from "gatsby-video"

const VideoPresentation = () => {
  const { videos } = useStaticQuery(graphql`
    {
      videos: allFile(
        filter: {
          relativePath: { eq: "home/9.mp4" }
          sourceInstanceName: { eq: "videos" }
        }
      ) {
        edges {
          node {
            childVideoFfmpeg {
              mp4: transcode {
                originalName
                src
                width
                height
                aspectRatio
                presentationMaxHeight
                presentationMaxWidth
                fileExtension
              }
            }
          }
        }
      }
    }
  `)
  const video = videos.edges[0].node.childVideoFfmpeg

  const blackWrapper = useRef(null)

  const loadVideo = () => {
    gsap.to(blackWrapper.current, {
      duration: 1.5,
      delay: 1,
      opacity: 0,
      ease: "power3.out",
    })
  }
  return (
    <>
      <div className="img-relative">
        <Video
          className="video-wrapper"
          preload="true"
          autoPlay
          muted
          loop
          sources={[video.mp4]}
          onLoadedData={loadVideo}
        />
      </div>
      <div className="black-wrapper" ref={blackWrapper}></div>
    </>
  )
}

export default VideoPresentation
